import { meetupProviderReturnUrl } from "~/utils/meetup-provider-return";
import type { ActionFunction, LoaderFunction } from "react-router";
import { useActionData, useSearchParams } from "react-router";
import { SAML } from "~/components/authentication/saml";
import { AppRoutes } from "~/utils/app-routes";
import { Link, useLocation } from "react-router";
import { useConfig } from "~/hooks/webconfig";
import usePageView from "~/hooks/page-view";
interface ActionData {
  error?: string;
}

export const loader: LoaderFunction = async ({ request }) => {
  return null;
};

export default function SignupSAMLRoute() {
  usePageView("Signup - SAML");
  const actionData = useActionData<ActionData>();
  const [searchParams] = useSearchParams();
  const config = useConfig();
  const location = useLocation();
  const previousUrl = meetupProviderReturnUrl(searchParams, config.identityUrl);

  // Get the full current URL for redirect handling on error
  const currentUrl = `${config.identityUrl}${location.pathname}${location.search}`;

  const handleSubmit = async (email: string) => {
    try {
      // Get the API URL from config
      const apiUrl = config.API;

      // Redirect to the SAML auth endpoint
      const authUrl = `${apiUrl}/saml/auth?email=${encodeURIComponent(email)}&redirectUrl=${encodeURIComponent(previousUrl)}&onError=${encodeURIComponent(currentUrl)}`;

      // The SAML auth endpoint will handle the redirect to the IdP
      window.location.href = authUrl;

      return;
    } catch (e) {
      console.error(e);
      return;
    }
  };

  return (
    <SAML
      error={actionData?.error || searchParams.get("error") || undefined}
      appRoutes={AppRoutes}
      routerUtils={{ Link, useLocation }}
      onSubmit={handleSubmit}
      mode="signup"
    />
  );
}
